import { useState } from "react";
import { Copy, Check } from "lucide-react";
import { toast } from "sonner";

export const CopyField = ({ label, value, testId, mono }) => {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(String(value));
    } catch {
      const ta = document.createElement("textarea");
      ta.value = String(value);
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      ta.remove();
    }
    setDone(true);
    toast.success("Kopyalandı");
    setTimeout(() => setDone(false), 1500);
  };
  return (
    <div>
      {label && <span className="x-label">{label}</span>}
      <div className="flex items-stretch rounded-md overflow-hidden border-2 border-[var(--x-border)] bg-[var(--x-bg-deep)]">
        <div data-testid={`${testId}-value`} className={`flex-1 px-3 py-2.5 text-[14px] font-semibold break-all ${mono ? "font-mono" : ""}`}>
          {value}
        </div>
        <button
          type="button"
          data-testid={`${testId}-copy-btn`}
          onClick={copy}
          className="px-3.5 bg-[var(--x-panel-2)] hover:bg-[#3d4357] transition-colors"
        >
          {done ? <Check size={16} className="text-[var(--x-green)]" /> : <Copy size={16} />}
        </button>
      </div>
    </div>
  );
};
